import { CSSProperties } from 'react';
import type { ColumnType } from 'antd/es/table/interface';

const buttonStyle: CSSProperties = {
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  padding: '4px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export const createDetailsColumn = <T,>(
  onOpen: (record: T) => void,
): ColumnType<T> => ({
  title: '',
  dataIndex: 'details',
  width: 50,
  align: 'center',
  render: (_: unknown, record: T) => (
    <button
      type="button"
      onClick={() => onOpen(record)}
      style={buttonStyle}
      title="Детали задания"
    >
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M6.75 4.5L11.25 9L6.75 13.5"
          stroke="#595959"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  ),
});
